<template>
    <select v-cloak class="d-none" :multiple="multiple">
        <option value="" disabled selected v-if="multiple!='multiple'">Seleccionar</option>
        <slot></slot>
    </select>
</template>
<script>
    export default {
        props: ['options', 'value', 'title', 'multiple'],

        mounted: function () {
            this.init()
        },

        methods: {
            init: function(){
                var vm = this
                $(this.$el)
                    .val(this.value)
                    .select2({
                        data: this.options,
                        placeholder: this.title || "Seleccionar",
                        allowClear: true,
                        width: '100%',
                        language: 'es',
                        templateSelection: function(data){
                            if (!data.element) {
                              return data.text;
                            }

                            var $element = $(data.element);

                            if(typeof($element[0].dataset.bold) != "undefined"){
                                var $wrapper = $('<span></span>');

                                var $bold = $element[0].dataset.bold;
                                var $html = '<strong>'+$bold+'</strong>';

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);

                                $wrapper.prepend($html);

                                return $wrapper;
                            }

                            if(typeof($element[0].dataset.icon) != "undefined"){
                                var $wrapper = $('<span></span>');

                                var $icon = $element[0].dataset.icon;
                                var $html = '<i class="'+$icon+'"></i>';

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);

                                $wrapper.prepend($html);

                                return $wrapper;
                            }

                            if(typeof($element[0].dataset.image) != "undefined"){
                                var $wrapper = $('<span></span>');

                                var $image = $element[0].dataset.image;
                                var $html = '<img class="shadow" style="max-width: 30%;" src="'+$image+'" height="25px" />';

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);

                                $wrapper.prepend($html);

                                return $wrapper;
                            }

                            return data.text;
                        },

                        templateResult: function (data) {
                            if (!data.element) {
                              return data.text;
                            }

                            var $element = $(data.element);

                            if(typeof($element[0].dataset.porcentaje) != "undefined"){
                                var $porcentaje = $element[0].dataset.porcentaje;
                                var $html = '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated bg-navy" role="progressbar" style="width: '+ $porcentaje +'%;" aria-valuenow="'+$porcentaje+'" aria-valuemin="0" aria-valuemax="100"></div></div>';

                                var $wrapper = $('<span></span>');

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);
                                $wrapper.append($html);

                                return $wrapper;
                            }

                            if(typeof($element[0].dataset.bold) != "undefined"){
                                var $wrapper = $('<span></span>');

                                var $bold = $element[0].dataset.bold;
                                var $html = '<strong>'+$bold+'</strong>';

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);

                                $wrapper.prepend($html);

                                return $wrapper;
                            }

                            if(typeof($element[0].dataset.icon) != "undefined"){
                                var $wrapper = $('<span></span>');

                                var $icon = $element[0].dataset.icon;
                                var $html = '<i class="'+$icon+'"></i>';

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);

                                $wrapper.prepend($html);

                                return $wrapper;
                            }

                            if(typeof($element[0].dataset.image) != "undefined"){
                                var $wrapper = $('<span></span>');

                                var $image = $element[0].dataset.image;
                                var $html = '<img class="shadow" style="max-width: 30%;" src="'+$image+'" height="25px" />';

                                $wrapper.addClass($element[0].className);

                                $wrapper.text(data.text);

                                $wrapper.prepend($html);

                                return $wrapper;
                            }

                            return data.text;
                        }
                    })
                    .on('change', function () {
                        vm.$emit('input', this.value)
                    })
            },

            update: function(){
                //var vm = this
                this.init()
                //$(this.$el).trigger('change')
            }
        },

        watch: {
            value: function (value) {
                $(this.$el).val(value).trigger('change');
            },

            options: function (options) {
                $(this.$el).select2({ data: options }).trigger('change')
            }
        },

        destroyed: function () {
            $(this.$el).off().select2('destroy')
        }
    }
</script>